import Vue from 'vue';
import VueMQ from 'vue-mq';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css';
import './assets/styles/style.sass';

import { i18n } from './translate';
import App from './App';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueMQ, {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity,
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js